<div class="select-field">
    @if (label) {
        <label class="select-label">{{ label | translate }}</label>
    }
    <div class="select-wrapper">
        <select
            class="select-control"
            [disabled]="disabled"
            (change)="onSelectChange($event)"
        >
            <option value="" [selected]="!value">{{ placeholder | translate }}</option>
            @for (option of options; track option.value) {
                <option [value]="option.value" [selected]="option.value === value">{{ option.label }}</option>
            }
        </select>
        <img src="assets/images/dropDownArrow.svg" alt="" class="select-arrow" />
    </div>
</div>
